import BaseApi from "../../../services/baseApi";

class Discount_se {
    constructor() {
        this.entity = 'discount';
    }
    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getMainJobList(id){
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/getMainJob/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }

    checkRemainder(){
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/check/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(value){
        let search=value;
        let formData=new FormData();
        formData.append("search",search,)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })
    }
    advancedSearch(model){
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:model,
            url: '/private/'+this.entity+'/advancedSearch',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new Discount_se();
